import { render } from "./Imagemap.vue?vue&type=template&id=48da9eca&scoped=true"
import script from "./Imagemap.vue?vue&type=script&lang=ts"
export * from "./Imagemap.vue?vue&type=script&lang=ts"

import "./Imagemap.vue?vue&type=style&index=0&id=48da9eca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48da9eca"

export default script